import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import StoreMixin from "./mixins/store.mixin";
import { domain, clientId, audience } from "./auth/auth0-variables.json";
import { VueLd } from "vue-ld";
import "./validator";
import VonexText from "@/components/forms/VonexText";
import VonexDate from "@/components/forms/VonexDate";
import VonexSelect from "@/components/forms/VonexSelect";
import VonexAutocomplete from "@/components/forms/VonexAutocomplete";
import VonexTextArea from "@/components/forms/VonexTextArea";
import VonexCheckbox from "@/components/forms/VonexCheckbox";
import VonexRadio from "@/components/forms/VonexRadio";
import MessageAlert from "@/components/common/MessageAlert";

Vue.component("message-alert", MessageAlert);
//  Vonex HOC
Vue.component("vonex-text", VonexText);
Vue.component(`vonex-date`, VonexDate);
Vue.component(`vonex-select`, VonexSelect);
Vue.component(`vonex-autocomplete`, VonexAutocomplete);
Vue.component(`vonex-textarea`, VonexTextArea);
Vue.component(`vonex-checkbox`, VonexCheckbox);
Vue.component(`vonex-radio`, VonexRadio);

// Import the plugin here
import { Auth0Plugin } from "./auth/authWrapper";

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  }
});
Vue.mixin(StoreMixin);
Vue.use(VueLd, {
  clientSideId: process.env.LAUNCHDARKLY,
  user: {
    anonymous: true
  },
  readyBeforeIdentify: false
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
